export enum ErrorCode {
  UnknownError = 'UnknownError',
  InvalidData = 'InvalidData',
  NotFound = 'NotFound',
  NotAllowedToMakeBooking = 'NotAllowedToMakeBooking',
  BookingSlotNotAvailable = 'BookingSlotNotAvailable',
  NotAllowedToChangeGroupBooking = 'NotAllowedToChangeGroupBooking',
  IntegrationError = 'IntegrationError',
}

export class BaseCustomError extends Error {
  public static tryCast(err: Error): BaseCustomError | undefined {
    if (BaseCustomError.isBaseCustomError(err)) {
      return err;
    }

    return undefined;
  }

  public static isBaseCustomError(err: Error | unknown): err is BaseCustomError {
    // errors thrown from nested dependencies returns false, so check if the error
    // has the httpErrorCode param, and then force it as a BaseCustomError
    // see #320
    if (err instanceof BaseCustomError) {
      return true;
    }
    if (typeof((err as any).httpErrorCode) === 'number') {
      return true;
    }

    return false;
  }

  public static isErrorCode(err: Error | unknown, code: ErrorCode) {
    if (BaseCustomError.isBaseCustomError(err)) {
      return err.errorCode === code;
    }
    return false;
  }

  constructor(
    public readonly httpErrorCode: number,
    message: string,
    public readonly data: any = {},
    public readonly errorCode: ErrorCode = ErrorCode.UnknownError,
  ) {
    super(message);
  }
}
